//Imports node_modules
import React from "react";
import ReactDOM from "react-dom/client";

//Imports Css
import './index.css'

//Imports Components
import App from './views/App'

//A <div></> root está na página ../public/index.html
const root = ReactDOM.createRoot(document.getElementById("root"));

//ATENÇÂO: O strict mode vai te dar dois render da página
//O que por si vai fazer a query duas vezes ao incio tornando a app mais lenta
//Assim que sair de desenvolvimento é importante tirar o <React.StrictMode>
root.render(
    <App></App>
);
